<script>
  import Button from '@components/buttons/button.svelte'
</script>

<div class="bg-yellow-100 text-yellow-900 border-b border-yellow-200 p-3 rounded-md flex justify-center items-center text-smaller">
  <p>Please check your email for a confirmation link to complete your registration.</p>
  <Button variant="naked" path="/user_confirmation/new" text="Send again." class="ml-1 underline hover:text-primary-700" />
</div>